var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.gameLink)?_c('Game',{attrs:{"onLeaveGame":_vm.onLeaveGame,"gameLink":_vm.gameLink,"backLink":_vm.backLink,"provider":_vm.provider,"token":_vm.token,"lobbyVersion":_vm.lobbyVersion,"linktoLobby":_vm.linktoLobby}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }